<div class="container-fluid">

  <div class="row s-contentheader">
    <div class="col-md-12">
      <div>
        <h2 class="text-center">{{customLabel('CATEGORIES', 'titleCTG') | titlecase}}</h2>
        <div class="s-dividerx"></div>
        <p>
          <!--<div class="input-group w-50 mx-auto">
              <input type="text" class="form-control s-round" placeholder="Rechercher dans les catalogues..." aria-label="Recipient's username" aria-describedby="basic-addon2">
              <span class="input-group-addon s-round"><i class="fa fa-search"></i></span>
          </div>-->
        </p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3">&nbsp;</div>
    <div class="col-md-7">
      <div class="row s-listcontent" *ngFor="let ct of categories">

        <div class="col-md-6" *ngFor="let c of ct.listFils">
          <div class="card s-listcard ispointer" (click)="selectCategory(c)">

            <div class="row no-gutters">
              <div class="col-auto">
                <div class="s-listcardborder" *ngIf="!c.ImgSrc || c.ImgSrc === ''">&nbsp;</div>
                <img [src]="store.getImgUrl(c.ImgSrc)" class="s-imgfluid" alt="" *ngIf="c.ImgSrc && c.ImgSrc !== ''">
              </div>
              <div class="col">
                <div class="card-block px-2 s-listcardblock">
                  <h5 [title]="c.Nom__CAT">{{c.Nom__CAT}}</h5>
                  <h6>{{c.Desc_CAT}}</h6>
                  <p>&nbsp;</p>
                </div>
              </div>

            </div>

            <div class="s-listcardfooter">
              <a (click)="selectCategory(c)" class="float-right mr-4"><i class="fa fa-search"></i></a>
              <span class="badge badge-light float-right mr-4">{{c.TotProducts}}</span>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="col-md-2">
      <button type="button" class="btn s-btncircle btn-lg s-btnbottom" (click)="store.openPage('/catalogsFormations/catalogs')">
        <i class="fa fa-arrow-left 2x"></i>
      </button>
    </div>
  </div>

</div>
